import { DELETE } from "../../API/delete";
import { GET } from "../../API/get";
import { FORMPOST, POST } from "../../API/post";
import { PUT } from "../../API/put";
import { getUserInfo } from "../../storage";

export const fetchFtmApprovalProcessSteps = async () => {
    const response = await GET("ftm/approval-process/steps");
    return response?.status === "Success" ? response : null;
};

export const fetchFtmIdentificationDetails = async (ftm_id) => {
    const response = await GET(`ftm/approval-process/identification/${ftm_id}`);
    return response?.status === "Success" ? response : null;
};

export const fetchFtmInfo = async (ftm_id) => {
    const response = await GET(`ftm/info/${ftm_id}`);
    return response?.status === "Success" ? response : null;
};

export const approvalProcessStep = async (ftm_id, step_key) => {
    const userInfo = getUserInfo();
    const response = await POST("ftm/process/step/approved", {
        ftm_id: ftm_id,
        admin_id: userInfo.admin_id,
        step_key: step_key
    });
    return response?.status === "Success" ? response : null
}

export const fetchPersonalDocumentTypes = async (ftm_id) => {
    const response = await GET(`personal-document-types/${ftm_id}`);
    return response?.status === "Success" ? response : null;
};

export const fetchPersonalDocumentTypeslist = async (ftm_id, documents_types_id, current_or_new_document) => {
    const response = await GET(`/ftm/personal/document-details/${ftm_id}/${documents_types_id}/${current_or_new_document}`);
    return response.status === "Success" ? response : null;
}

export const uploadDocuments = async ({ ftm_id, ftm_document_type_id, ftm_document_type, document_type, ftm_document, ftm_is_registering = 1 }) => {
    const response = await FORMPOST(`upload-ftm-documents`, {
        ftm_id,
        ftm_document_type_id,
        ftm_document_type,
        ftm_is_registering: ftm_is_registering,
        document_type,
        ftm_document,
        is_ftm_web_registration: 1
    });

    return response.status === "Success" ? response : null;
}

export const deleteDocument = async (document_file_id) => {
    const response = await DELETE(`ftm/personal/document/${document_file_id}`);
    return response.status === "Success" ? response : null;
};

export const updateExpiryDocument = async ({document_id, expiry_date, comment, document_type}) => {
    const response = await PUT(`ftm/documents/expiry-date`,{
        document_id,
        expiry_date,
        comment,
        document_type
    });
    
    return response.status === "Success" ? response : null;
};

export const fetchDocumentsExpiryDateAndComment = async (document_id, document_type) => {
    const response = await GET(`ftm/personal/documents/expiry-date-and-comment/${document_type}/${document_id}`);
    return response.status === "Success" ? response : null;
}

export const certificatesAndDocumentApprove = async ({document_id, document_type}) => {
    const userInfo = getUserInfo();
    const response = await PUT(`ftm/approve/document`,{
       document_id, 
       document_type,
       document_approved_admin_id: userInfo.admin_id
    });
    
    return response.status === "Success" ? response : null;
}

export const fetchFtmCertificatesList = async ({ftm_id, action = 0, current_ftm_skill_id = 0}) => {
    const response = await GET(`ftm/approval-process/skills-certificates/${ftm_id}/${action}/${current_ftm_skill_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchCertificates = async ({ftm_id, documents_types_id}) => {
    const response = await GET(`ftm/approval-process/certificates/${ftm_id}/${documents_types_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchDocumentTypes = async (ftm_id) => {
    const response = await GET(`ftm/unregistered/document/types/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchDocuments = async (ftm_id, document_type_id, current_or_new_document) => {
    if (!document_type_id) return null;
    
    const response = await GET(`ftm/certificates/documents/${ftm_id}/${document_type_id}/${current_or_new_document}`);
    return response.status === "Success" ? response : null;
}

export const deleteCertificate = async (document_file_id) => {
    const response = await DELETE(`ftm/document/${document_file_id}`);
    return response.status === "Success" ? response : null;
};

export const fetchFtmSkills = async (ftm_id) => {
    const response = await GET(`ftm/approval-process/skills/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchFtmDocumentsTypes = async (ftm_id, sub_skill_id) => {
    const response = await GET(`ftm/approval-process/documents-types/${ftm_id}/${sub_skill_id}`);
    return response.status === "Success" ? response : null;
}

export const updateFtmSkillApprove = async (ftm_skill_id, ftm_id) => {
    const response = await PUT("is/approve/ftm/skill", {
        is_approve: 1,
        ftm_skill_id: ftm_skill_id,
        ftm_id: ftm_id,
        is_approval_process: 1
    });
    
    return response.status === "Success" ? response : null;
}

export const fetchTrackerDetails = async (ftm_id) => {
    const response = await GET(`ftm/approval-process/tracker-details/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const updateDevice = async (ftm_id, ftm_device_id) => {
    const userInfo = getUserInfo();

    const response = await POST("setup/gps/device", { ftm_id, ftm_device_id, admin_id: userInfo.admin_id});
    return response.status === "Success" ? response : null;
}

export const deleteDevice = async (ftm_id) => {
    const response = await PUT("remove/gps/device", { ftm_id });
    return response.status === "Success" ? response : null;
}

export const uploadPackageImage = async ({ftm_id, package_image}) => {
    const userInfo = getUserInfo();
    const response = await FORMPOST("upload/ftm/label", {
        ftm_id: ftm_id,
        admin_id: userInfo.admin_id,
        package_image: package_image
    });

    return response.status === "Success" ? response : null;
}

export const trackerDispatch = async (ftm_id) => {
    const userInfo = getUserInfo();
    const response = await PUT("tracker/dispatched", { ftm_id, admin_id: userInfo.admin_id });
    return response.status === "Success" ? response : null;
}

export const trackerActiveAndReceiving = async (ftm_id) => {
    const userInfo = getUserInfo();
    const response = await PUT("ftm/tracker/active-and-receiving-locations-manually", { ftm_id, admin_id: userInfo.admin_id });
    return response.status === "Success" ? response : null;
}

export const fetchApprovalProcessHistory = async (ftm_id) => {
    const response = await GET(`ftm/approval-process/history//${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const updateFtmApproveAndReject = async (ftm_id, ftm_is_verify, reason = "") => {
    const userInfo = getUserInfo();
    const response = await PUT("ftm-is-verify", {
        ftm_id: ftm_id,
        ftm_is_verify: ftm_is_verify,
        ftm_reject_reason: reason,
        admin_id: userInfo.admin_id
    });

    return response.status === "Success" ? response : null;
}

export const updateSimNumber = async (ftm_id, sim_number) => {
    const userInfo = getUserInfo();
    const response = await POST("ftm/tracker/sim-setup", { ftm_id, tracker_sim_number: sim_number, admin_id: userInfo.admin_id});
    return response.status === "Success" ? response : null;
}

export const deleteSimNumber = async (ftm_id) => {
    const response = await PUT("ftm/tracker/sim-remove", { ftm_id });
    return response.status === "Success" ? response : null;
}

export const updateTrackerInstalled = async (ftm_id) => {
    const userInfo = getUserInfo();
    const response = await PUT("ftm/tracker/installed", { ftm_id, admin_id: userInfo.admin_id });
    return response.status === "Success" ? response : null;
}

export const updateFtmProfileImage = async (ftm_id) => {
    const response = await PUT("ftm/profile/image/approved", { ftm_id });
    return response?.status === "Success" ? response : null
}

export const fetchFtmCurrentLocation = async (ftm_id) => {
    const response = await GET(`ftm/current/location/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const ftmBackgroundIsChecked = async (ftm_id) => {
    const userInfo = getUserInfo();
    const response = await PUT("ftm/background/is/check", { ftm_id, admin_id: userInfo.admin_id, ftm_background_is_check: 1 });
    return response.status === "Success" ? response : null;
}